import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Relatives } from 'rp-bloodstock-search';
import { profileUrl } from '../../helpers/urlBuilder';

export default class RelativesRow extends Component {
    static propTypes = {
        // own
        className: PropTypes.string,
        colSpan: PropTypes.number.isRequired,
        venueId: PropTypes.number.isRequired,
        saleEndDate: PropTypes.string.isRequired,
        damDateOfBirth: PropTypes.string,
        data: PropTypes.shape({
            lot_no: PropTypes.number.isRequired,
            lot_letter: PropTypes.string,
            dam_uid: PropTypes.number,
            catalogue_pedigree_pdf_url: PropTypes.string,
            sire_uid: PropTypes.string.isRequired,
            sire_styled_name: PropTypes.string.isRequired,
        }).isRequired,
        scrollToRow: PropTypes.bool.isRequired,
        showShortlist: PropTypes.bool.isRequired
    };

    static get defaultProps() {
        return {
            scrollToRow: false,
            damDateOfBirth: ''
        };
    }

    static didScroll = false;

    componentDidMount() {
        this.scrollIntoView();
    }

    scrollIntoView = () => {
        if (window.history && window.history.scrollRestoration) {
            window.history.scrollRestoration = 'manual';
        }

        if (this.props.scrollToRow && !RelativesRow.didScroll) {
            this.row.scrollIntoView({ block: 'start', behavior: 'smooth' });
            RelativesRow.didScroll = true;
        }
    };

    render() {
        const {
            className,
            colSpan,
            venueId,
            saleEndDate,
            data,
            showShortlist,
            damDateOfBirth
        } = this.props;
        const catalogueUrl = data.catalogue_pedigree_pdf_url
            ? data.catalogue_pedigree_pdf_url.replace(/^(?!http)/, 'http://')
            : null;
        return (
            <tr ref={(node) => { this.row = node; }}>
                <td colSpan={colSpan}>
                    <div className={className}>
                        <Relatives
                            damUid={data.dam_uid}
                            venueId={venueId}
                            saleDate={data.sale_date}
                            saleEndDate={saleEndDate}
                            birthDate={damDateOfBirth}
                            lotNo={data.lot_no}
                            lotLetter={data.lot_letter}
                            catalogueUrl={catalogueUrl}
                            showShortlist={showShortlist}
                            sireUrl={profileUrl(
                                'horse',
                                data.sire_uid,
                                data.sire_style_name,
                            )}
                        />
                    </div>
                </td>
            </tr>
        );
    }
}



// WEBPACK FOOTER //
// ./src/js/components/DataTable/RelativesRow.js